module.exports = fox._r("fonts/mc-admin-common.ttf", __webpack_public_path__ + "_/_/_/common/frame/fonts/PnC6Tze.ttf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/fonts/mc-admin-common.ttf
// module id = 115
// module chunks = 2